import type { FaireProductEntity } from "../../entity_types/product";

export const p_ct3ntb6zdu: FaireProductEntity = {
  token: "p_ct3ntb6zdu",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Chloris",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/66726b95a725933c1a3911f94931069ebf2fa9a4850f2877b8f72497ac520b02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86caf0af8b0436ef3a5080450b9a7d49dc2af5aa724394b9e05d935ddeb2b5db.jpeg",
    "https://cdn.faire.com/fastly/f0508fe41869df3168051972e0adae6027f04cdeeed0f226b351f6b82eec0ad2.jpeg",
    "https://cdn.faire.com/fastly/022d520888a52f9d1e1a4adf5d10315e82ed05f0bf6e5fd2cc7ab1814698451a.jpeg",
    "https://cdn.faire.com/fastly/afb0e2f0aa61f3444fba32883b216217bd598362094e516c0207e1f181b0fe08.jpeg",
    "https://cdn.faire.com/fastly/574ab53be45269e0f8d3319d70ea63c67e2d9efcf454a28a29eca78868dfd28e.jpeg",
    "https://cdn.faire.com/fastly/2bf662632235268e852dd75f46ed6e98ee3fc9ee1eeeecada5d5dee57a615a6e.jpeg",
    "https://cdn.faire.com/fastly/1cedd16ba71a3fdfb2ac08ab7edbe6add92cb32c3dd6147e57d3b498bbefb78a.jpeg",
    "https://cdn.faire.com/fastly/aa40ab09a468e032311900042746691c8d67f94e0682596f9bb92960b2c1088b.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:28.285Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
